<template>
  <el-row :gutter="20" style="margin-top: 35px">
    <el-form>
      <el-form-item style="text-align: center">
        <el-radio v-model="ruleForm.model" label="0"
          >Zebra<br />
          <img src="/img/zebra4x1.png" style="margin-left: 23px"
        /></el-radio>
        <el-radio v-model="ruleForm.model" label="1"
          >1 por folha<br />
          <img src="/img/etiqueta4x1.png" style="margin-left: 28px"
        /></el-radio>
        <el-radio v-model="ruleForm.model" label="2"
          >2 por folha<br />
          <img src="/img/etiqueta4x2.png" style="margin-left: 28px"
        /></el-radio>
        <el-radio v-model="ruleForm.model" label="4"
          >4 por folha<br />
          <img src="/img/etiqueta4x4.png" style="margin-left: 28px"
        /></el-radio>
      </el-form-item>
      <el-form-item v-show="hasWarnihg">
        <el-checkbox v-model="ruleForm.warning" autocomplete="off">Imprimir Aviso Recebimento</el-checkbox>
      </el-form-item>
      <el-form-item v-show="hasDeclared">
        <el-checkbox v-model="ruleForm.declared" autocomplete="off">Imprimir Declaração Conteudo</el-checkbox>
        <el-radio :disabled="!ruleForm.declared" v-model="ruleForm.type" label="1">Para todas as etiquetas</el-radio>
        <el-radio :disabled="!ruleForm.declared" v-model="ruleForm.type" label="2"
          >Somente que possuem declaração</el-radio
        >
      </el-form-item>
      <el-form-item v-show="hasSeparator">
        <el-checkbox v-model="ruleForm.separator" autocomplete="off">Arquivos separados</el-checkbox>
      </el-form-item>
    </el-form>
  </el-row>
</template>

<script>
export default {
  computed: {
    hasSeparator() {
      return this.state["FULL"] || this.state["SHOW_SEPARATOR"];
    },
    hasWarnihg() {
      return this.state["FULL"] || this.state["SHOW_WARNING"];
    },
    hasDeclared() {
      return this.state["FULL"] || this.state["SHOW_DECLARED"];
    },
  },
  props: ["state"], // opções FULL, SHOW_WARNING, SHOW_DECLARED, SHOW_SEPARATOR. Ex.: { status = { FULL: true } }
  data() {
    return {
      ruleForm: {
        model: "0",
        warning: false,
        declared: false,
        type: "1",
        separator: false,
      },
    };
  },
  methods: {
    getForm() {
      return this.ruleForm;
    },
  },
};
</script>
